<template>
  <BaseAlert
    color="text-warning"
    :text="t('Ознакомьтесь с ограничениями на приём у врача в этой клинике', options)"
    :link-text="t('Смотреть', options)"
    @click:link="emit('open-appointment-restrictions')"
  />
</template>

<script lang="ts" setup>
import I18NextVue from 'i18next'
import BaseAlert from 'www/vue_components/common/core/BaseAlert.vue'

type Emits = {
  (_e: 'open-appointment-restrictions'): void,
}

const emit = defineEmits<Emits>()

const { t, language } = I18NextVue
const options = { ns: language }
</script>
